export class RolParametroAutonomia {
    idRol: number;
    idParametroAutonomia: number;
    idEmpresa: number;
    valorMin?: number;
    valorMax?: number;
    userSave: string;
    dateSave: string;
    rol: string;
    parametro: string;
}
